export default "__VITE_ASSET__16bfe25e__"